import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh',
          background: 'var(--paper)', color: 'var(--ink)',
          fontFamily: 'var(--font-sans)', gap: 'var(--space-4)', padding: 'var(--space-6) var(--space-4)', textAlign: 'center'
        }}>
          <h2 className="ap-headline">Algo deu errado</h2>
          <p className="ap-caption" style={{ margin: 0, maxWidth: 400 }}>
            Ocorreu um erro inesperado. Recarregue a página para continuar.
          </p>
          <button type="button" onClick={() => window.location.reload()} className="ap-btn ap-btn-primary">
            Recarregar
          </button>
          {process.env.NODE_ENV !== 'production' && this.state.error && (
            <pre style={{
              margin: 'var(--space-4) 0 0', padding: 'var(--space-3)', background: 'var(--paper-raised)',
              border: '1px solid var(--rule)', borderRadius: 0, font: '400 13px/18px monospace', textAlign: 'left',
              maxWidth: '100%', overflow: 'auto', color: 'var(--signal-negative)'
            }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
